export const getChapterUrl = (brandSlug: string, chapterSlug: string): string => {
  return `/${brandSlug}/${chapterSlug}`;
};
